import React, {useState} from 'react';
import {TextField} from '@mui/material';
import {useSelector} from 'react-redux';
import Typography from "@mui/material/Typography";
import {writeTeamName} from "../../helpers/dbFunctions";
import AlertDialog from "../common/AlertDialog";
import {Flex} from "reflexbox";
import {Edit, Info} from "@mui/icons-material";
import CustomTooltip from "../common/CustomTooltip";
import profanityChecker from "../helpers/profanityChecker";

const TeamNameDisplayAndEdit = () => {
  const { currentTeamId, teamDetails } = useSelector((state) => state.team);

  const [teamName, setTeamNameLocal] = useState(teamDetails?.teamName || '');
  const [openDialog, setOpenDialog] = useState(false);
  const [profanityError, setProfanityError] = useState(false);

  const handleInputChange = (event) => {
    setTeamNameLocal(event.target.value);
    const containsProfanity = profanityChecker(event.target.value);
    setProfanityError(containsProfanity);
  };

  const handleSaveTeamName = () => {
      !profanityError && writeTeamName(currentTeamId, teamName)
  };

  return (
    <>
      <Flex>
        <Typography style={{fontWeight: 'bold', paddingRight: '4px'}}>Team name </Typography>
        <CustomTooltip display={{display: 'inline-block'}}
                       title={<>This name will be used for the leaderboard</>}
                       triggerComponent={<Info fontSize={'small'} color={'primary'}/>}
        />
      </Flex>
      <Flex onClick={() => setOpenDialog(true)} style={{paddingTop: '4px', display: 'inline-flex'}}>
        <Typography style={{paddingRight: '4px'}}>{teamDetails?.teamName || 'None Set'} </Typography>
        <Edit fontSize="small" sx={{ color: 'text.secondary' }}/>
      </Flex>
      <AlertDialog
        open={openDialog}
        close={() => setOpenDialog(false)}
        title={'Update Team Name'}
        body={<Flex style={{flexDirection: 'column'}}>
          <TextField
            label="Team Name"
            value={teamName}
            onChange={handleInputChange}
          />
          {profanityError &&
          <Typography variant={'caption'} color={'secondary'} style={{paddingTop: '4px'}}>This name does not meet our community guidelines. Please use a different name </Typography>}
        </Flex>}
        continue={handleSaveTeamName}
        continueDisabled={profanityError}
        rightButtonText={'Save'}
      />
    </>
  );
};

export default TeamNameDisplayAndEdit;